import { Controller } from '@hotwired/stimulus';
import { showLoadingSpinner } from '../../modules/checkout/loadingSpinner';

export default class extends Controller {
  // eslint-disable-next-line class-methods-use-this
  show () {
    showLoadingSpinner();
  }
}
